module.exports = __webpack_public_path__ + "img/top.8a0cf6b7.jpg";